module.exports = __webpack_public_path__ + "img/dMgREcoh.6614166b.svg";